import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { DOOD_API } from '@config/ws.config';
import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

@Injectable({ providedIn: 'root' })
export class MarketplaceOrderingApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly cb2PreviewState = inject(Cb2PreviewStateService);

  getOrderingAvailable$(marketplaceId: string): Observable<{ orderable: boolean }> {
    if (this.cb2PreviewState.isActive()) {
      return of({ orderable: true });
    }
    return this.httpClient.get<{ orderable: boolean }>(
      `${DOOD_API}/marketplaces/${marketplaceId}/ordering-available`,
    );
  }
}
